<template>
  <v-app-bar class="container elevation-0" height="48px" app style="padding-top: 0px; max-width: 1400px; margin: 0 auto">
    <v-btn icon :href="urlSite">
      <v-icon alt="Retornar ao Site" title="Retornar ao Site">home</v-icon>
    </v-btn>
    <v-spacer></v-spacer>

    <router-link to="/assine">
      <v-btn icon v-if="this.$store.state.site.paywall && (!$store.state.login || !$store.state.usuario.idDependente)">
        <v-icon alt="Assine" title="Assine">add_shopping_cart</v-icon>
      </v-btn>
    </router-link>
    <router-link to="/newflip">
      <v-btn icon v-if="$store.state.site.flip">
        <v-icon alt="Flip" title="Flip">flip</v-icon>
      </v-btn>
    </router-link>
    <router-link to="/assinaturas" v-if="$store.state.login && !$store.state.usuario.idDependente && this.$store.state.site.assinante">
      <v-btn icon>
        <v-icon alt="Minhas Assinaturas" title="Minhas Assinaturas">assignment</v-icon>
      </v-btn>
    </router-link>
    <router-link to="/meus-dados" v-if="$store.state.login && !$store.state.usuario.idDependente && this.$store.state.site.assinante">
      <v-btn icon>
        <v-icon alt="Meus Dados" title="Meus Dados">account_circle</v-icon>
      </v-btn>
    </router-link>
    <router-link to="/alterar-senha" v-if="$store.state.login">
      <v-btn icon>
        <v-icon alt="Alterar Senha" title="Alterar Senha">lock</v-icon>
      </v-btn>
    </router-link>
    <v-btn
      icon
      v-if="$store.state.login && (this.$store.state.site.paywall || this.$store.state.site.assinante || (this.$store.state.site.flip && !this.$store.state.site.flipPublico))"
    >
      <v-icon @click="deslogar" title="Sair">open_in_new</v-icon>
    </v-btn>
    <router-link
      to="/login"
      v-if="!$store.state.login && (this.$store.state.site.paywall || this.$store.state.site.assinante || (this.$store.state.site.flip && !this.$store.state.site.flipPublico))"
    >
      <v-btn icon>
        <v-icon alt="Acessar" title="Acessar">exit_to_app</v-icon>
      </v-btn>
    </router-link>
    <v-btn x-small icon color="grey lighten-1">
      <v-icon :alt="'versão ' + $store.state.versao" :title="'versão ' + $store.state.versao">contact_support</v-icon>
    </v-btn>
  </v-app-bar>
</template>

<script>
import util from "../util";
export default {
  data() {
    return {
      urlSite: this.$route.path
    };
  },
  methods: {
    async deslogar() {
      try {
        await this.$store.dispatch("deslogarUsuario");
      } catch (e) {
        return;
      }
    }
  },
  async created() {
    do {
      await util.delay(1000);
    } while (!this.$store.state.site.enderecoSite);

    if (this.$route.query.logoff && localStorage.getItem("pwK")) {
      var strSite = this.$store.state.site.enderecoSite;
      await this.deslogar();
      window.location = strSite;
    }
    this.urlSite = this.$store.state.site.enderecoSite;
    if (this.$store.state.site.redirect_uri && localStorage.getItem("pwK")) {
      this.urlSite += "?state=" + this.$store.state.site.enderecoSite + "?code=" + localStorage.getItem("pwK");
    }
  }
};
</script>
